
import { Vue, Component, Prop } from "vue-property-decorator";
import { validateAndFormatPhoneNumber } from "@/utils/phoneValidation";

interface Contact {
  emergency_contact_name: string;
  emergency_relationship: string;
  emergency_phone_number: string;
  emergency_secondary_contact: string;
  emergency_additional_notes: string;
}


@Component
export default class EmergencyContact extends Vue {
  @Prop({ required: true }) readonly data!: Contact;

  get formattedPhoneNumber(): string {
    if (!this.data.emergency_phone_number) {
      return 'N/A';
    }
    
    const result = validateAndFormatPhoneNumber(this.data.emergency_phone_number, 'us');
    return result.formatted || this.data.emergency_phone_number;
  }
}
